import { buildPageableParams, Page, PageableArgs } from '@common/services';
import { ArchiveKarousselDto, ArchiveKarousselProjection } from '@common/services/archive-karoussel';
import { queryDownloadFile } from '../common/pageable/query-download-file';
import { queryUntilLastPage } from '../common/pageable/query-until-last-page';
import { servicesApi } from '../services';

const ORGANISME_ARCHIVE_KAROUSSEL_URL_PREFIX = (id: number) => `organismes/${id}/archive-karoussel`;

const organismeArchiveKarousselApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getOrganismeArchivesKaroussel: build.query<Page<ArchiveKarousselDto>, GetOrganismeArchivesKarousselQueryArgs, any>({
      query: ({ id, ...pageable }) => ({
        url: ORGANISME_ARCHIVE_KAROUSSEL_URL_PREFIX(id),
        params: buildPageableParams(pageable),
      }),
      providesTags: ['ArchivesKaroussel'],
    }),

    getAllOrganismeArchivesKaroussel: build.query<ArchiveKarousselDto[], GetAllOrganismeArchivesKarousselQueryArgs, any>({
      queryFn: ({ id, projection }, _api, _extraOptions, baseQuery) => queryUntilLastPage({
        baseQuery,
        url: ORGANISME_ARCHIVE_KAROUSSEL_URL_PREFIX(id),
        params: { projection },
      }),
      providesTags: ['ArchivesKaroussel'],
    }),

    downloadOrganismeArchiveKaroussel: build.mutation<void, DownloadOrganismeArchiveKarousselMutationArgs, any>({
      queryFn: ({ id, archiveId }, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${ORGANISME_ARCHIVE_KAROUSSEL_URL_PREFIX(id)}/${archiveId}/resource`,
      }),
    }),
  }),
});

interface GetOrganismeArchivesKarousselQueryArgs extends PageableArgs<ArchiveKarousselProjection> {
  id: number;
}

interface GetAllOrganismeArchivesKarousselQueryArgs {
  id: number;
  projection: ArchiveKarousselProjection;
}

interface DownloadOrganismeArchiveKarousselMutationArgs {
  id: number;
  archiveId: number;
}

export const {
  useGetOrganismeArchivesKarousselQuery,
  useGetAllOrganismeArchivesKarousselQuery,
  useDownloadOrganismeArchiveKarousselMutation,
} = organismeArchiveKarousselApi;